import React from "react";
import {
  FooterLogo,
  SocialIcon,
  FooterSocialIcon,
  FooterWrapper,
  FooterColumn,
  FooterAddress,
  FooterSocialGroup,
} from "./styles";
import { footerSocialData } from "../../data/FooterData";
import { Section } from "../../AppStyle";
import { useTheme } from "../Theme/ThemeProvider.js";

function Footer() {
  const { isDarkMode } = useTheme();

  return (
    <Section padding="4rem 0 2rem 0">
      <FooterWrapper>
        <FooterLogo to="/">
          <SocialIcon
            src={
              isDarkMode
                ? "./assets/dark/primatio-medium-dark.png"
                : "./assets/light/primatio-medium-light.png"
            }
          />
        </FooterLogo>
        <FooterColumn id="footerLogo">
          <FooterAddress isDarkMode={isDarkMode}>
            <h3>&copy; Primatio Cyber Security ltda. 44.910.138-0001/01</h3>
          </FooterAddress>
          <FooterAddress isDarkMode={isDarkMode}>
            Rua Do Brum, 248 - Cxpst 35, Recife, Pernambuco, 50030-260
          </FooterAddress>
          <FooterAddress isDarkMode={isDarkMode}>
            Rua Tomás Ribeiro, n° 41, 1° esquerdo, Lisboa, Código Postal:
            1050-225 (Responsável: Dra. Alyne Andrade)
          </FooterAddress>
          <FooterAddress isDarkMode={isDarkMode}>
            Entre em contato conosco: <a href="mailto:felipe@primat.io" style={{color: isDarkMode ? '#fff' : '#000'}}>felipe@primat.io</a>
          </FooterAddress>
        </FooterColumn>
        <FooterSocialGroup>
          {footerSocialData.map((social, index) => (
            <FooterSocialIcon
              key={index}
              href={social.link}
              target="_blank"
              aria-label={social.name}
              isDarkMode={isDarkMode}
            >
              {social.icon}
            </FooterSocialIcon>
          ))}
        </FooterSocialGroup>
      </FooterWrapper>
    </Section>
  );
}

export default Footer;
